<template>
  <div class="sy-currency">
    <component :is='componentName' v-bind='{...$props}' v-model.trim="value" v-on="$listeners"></component>
  </div>
</template>

<script>
  import thousandsInput from '../number/components/thousandsInput.vue'
  import readCurrency from './components/read-currency.vue'
  import {currencyProps} from './index'

  export default {
    components: {
      thousandsInput,
      readCurrency
    },
    props: currencyProps,
    model: {
      prop: 'value',
      event: '_change'
    },
    computed: {
      componentName () {
        if (this.isPureText) {
          return 'read-currency'
        }
        return 'thousands-input'
      }
    },
    watch: {
      value (val) {
        this.$emit('_change', val)
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-currency {
    ::v-deep .el-input__inner {
      height: 32px;
    }
  }
</style>
